import './index.scss';
import _ from 'lodash';

export const Loading = ({ message, centered }) => {
  const extraClasses = _.compact([
    centered && 'w-100 py-12 justify-content-center my-12',
    !centered && 'p-6',
  ]).join(' ');
  return (
    <div data-testid="loading-spinner" className={`d-flex align-items-center gap-6 ${extraClasses}`}>
      <div className="spinner-border" role="status" />
      <span className="">{message || 'Loading...'}</span>
    </div>
  );
};

export const LoadingIndicator = ({ isLoading, children, ...rest }) => (isLoading
  ? <Loading {...rest} />
  : children);
